import React from 'react'
import CustomTag from 'components/CustomTag'

const InderViewerStatus = ({ is_available }) => {
  let colorType
  let tagMessage
  if (!is_available) {
    colorType = 'grey'
    tagMessage = 'Unavailable'
  } else if (is_available) {
    colorType = 'green'
    tagMessage = 'Available'
  }
  return (
    <CustomTag colorType={colorType} message={tagMessage} bordered={false} />
  )
}

export default InderViewerStatus
